import { useAuth } from '../context/AuthContext';
import { useAppConfig } from '../context/AppConfigContext';

export const useFeatureGate = () => {
  const { user, isPro } = useAuth();
  const { config } = useAppConfig();

  const tier = isPro ? config.proTier : config.freeTier;

  return {
    isAuthenticated: !!user,
    isPro,
    canDownloadFormat: (format) =>
      tier.allowedDownloadFormats.includes(format.toLowerCase()),
    canUseTemplate: (template) => tier.allowedTemplates.includes(template),
    maxSavedQRCodes: isPro ? Infinity : (config.freeTier.maxSavedQRCodes ?? 10),
    canSaveQRCodes: !!user,
    canUseDynamicQR: isPro && (config.featureFlags?.dynamicQREnabled ?? false),
    canViewAnalytics: isPro && (config.featureFlags?.analyticsEnabled ?? false),
    trialPeriodDays: config.pricing?.trialPeriodDays ?? 7,
    proMonthlyPrice: config.pricing?.proMonthlyPrice ?? 5,
  };
};
